{
  "familyId": "GELD-MAAK",
  "questions": [
    {
      "id": "GELD-MAAK-001",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €2,75 met munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€2,75", "€2,70", "€2,80", "€3,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 275,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 275, "breakdown": {"coins": [{"value": 200, "count": 1}, {"value": 50, "count": 1}, {"value": 20, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "label": "Zo maak je €2,75: €2 + 50 cent + 20 cent + 5 cent = €2,75"}, "a11y": {"alt": "Uitleg: €2 + 50 cent + 20 cent + 5 cent = €2,75"}}],
      "conceptId": "make_amount_coins",
      "variantIndex": 1,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Stopt bij €2,70 en vergeet de laatste 5-centmunt", "optionIndex": 1 },
        { "id": "geld.optel-fout", "label": "Pakt een munt te veel (€2,80)", "optionIndex": 2 },
        { "id": "geld.afronden-naar-50", "label": "Rondt onterecht af naar een rond bedrag (€3,00)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak eerst €2 (grootste munt ≤ €2,75). Je hebt nog 75 cent nodig: pak 50 cent, dan 20 cent, dan 5 cent. Tel op: €2 + 50 cent + 20 cent + 5 cent = €2,75.",
        "distractorExplanations": {
          "0": "Goed! €2 + 50 cent + 20 cent + 5 cent = €2,75. Onthoud: pak altijd de grootste munt die past en tel daarna na of je precies uitkomt.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €2,70. Maar €2,70 is 5 cent te weinig — je mist nog een 5-centmunt. Onthoud: tel na het maken altijd je totaal na.",
          "2": "Je dacht waarschijnlijk dat je een munt extra nodig had. Maar €2,80 is 5 cent te veel. Onthoud: het moet precies kloppen, niet meer.",
          "3": "Je dacht waarschijnlijk dat je naar een rond bedrag mocht afronden. Maar €3,00 is 25 cent te veel. Onthoud: bij geld maken rond je nooit af — maak precies het bedrag."
        }
      }
    },
    {
      "id": "GELD-MAAK-002",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €4,50 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€4,50", "€4,00", "€5,00", "€4,40"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 450,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 450, "breakdown": {"coins": [{"value": 200, "count": 2}, {"value": 50, "count": 1}]}, "showCoins": true, "label": "Zo maak je €4,50: 2×€2 + 1×50 cent = €4 + 50 cent = €4,50"}, "a11y": {"alt": "Uitleg: €2 + €2 + 50 cent = €4,50"}}],
      "conceptId": "make_amount_round",
      "variantIndex": 2,
      "citoDifficulty": 0.13,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Vergeet de 50 cent achter de komma (€4,00)", "optionIndex": 1 },
        { "id": "geld.optel-fout", "label": "Pakt een munt te veel (€5,00)", "optionIndex": 2 },
        { "id": "geld.optel-fout", "label": "Verkeerde centmunten gepakt: 2×20 i.p.v. 50 (€4,40)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak twee munten van €2 (samen €4). Je hebt nog 50 cent nodig: pak 1 munt van 50 cent. Tel op: €2 + €2 + 50 cent = €4,50.",
        "distractorExplanations": {
          "0": "Goed! €2 + €2 + 50 cent = €4,50. Onthoud: maak eerst de hele euro's, kijk daarna naar het bedrag achter de komma.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €4,00. Maar dan mis je de 50 cent achter de komma. Onthoud: kijk altijd ook naar het bedrag achter de komma.",
          "2": "Je dacht waarschijnlijk dat je een munt extra nodig had. Maar €5,00 is 50 cent te veel. Onthoud: het moet precies €4,50 zijn.",
          "3": "Je dacht waarschijnlijk dat 2×20 cent genoeg was voor de centen. Maar dat is 40 cent, niet 50 cent. Onthoud: één munt van 50 cent is precies een halve euro."
        }
      }
    },
    {
      "id": "GELD-MAAK-003",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €6,35 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€6,35", "€6,53", "€5,35", "€7,35"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 635,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 635, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 100, "count": 1}, {"value": 20, "count": 1}, {"value": 10, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "showBills": true, "label": "Zo maak je €6,35: €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35"}, "a11y": {"alt": "Uitleg: €5 biljet + €1 munt + 20 cent + 10 cent + 5 cent = €6,35"}}],
      "conceptId": "make_amount_bills",
      "variantIndex": 3,
      "citoDifficulty": 0.17,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.cent-als-decimaal-verward", "label": "Draait de centen om: 53 i.p.v. 35 (€6,53)", "optionIndex": 1 },
        { "id": "geld.munt-vergeten", "label": "Vergeet de €1-munt (€5,35)", "optionIndex": 2 },
        { "id": "geld.optel-fout", "label": "Pakt een €1 te veel (€7,35)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Begin met het grootste biljet dat past en werk naar beneden. Pak een biljet van €5. Je hebt nog €1,35 nodig: pak €1, dan 20 cent, dan 10 cent, dan 5 cent. Tel op: €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35.",
        "distractorExplanations": {
          "0": "Goed! €5 + €1 + 20 cent + 10 cent + 5 cent = €6,35. Onthoud: lees het bedrag van links naar rechts en maak het in dezelfde volgorde.",
          "1": "Je dacht waarschijnlijk aan 53 cent, maar het bedrag vraagt 35 cent. Onthoud: let goed op de volgorde van de cijfers achter de komma — 35 is niet hetzelfde als 53.",
          "2": "Je dacht waarschijnlijk dat €5 plus de centen genoeg was. Maar dan mis je nog €1. Onthoud: na €5 heb je nog €1,35 nodig, dus eerst de €1-munt erbij.",
          "3": "Je dacht waarschijnlijk dat je een munt extra nodig had. Maar €7,35 is €1 te veel. Onthoud: controleer of je niet per ongeluk een extra €1 hebt gepakt."
        }
      }
    },
    {
      "id": "GELD-MAAK-004",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €8,20 met zo min mogelijk munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€8,20", "€8,00", "€8,30", "€8,10"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 820,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"preferMinimalTokens": true, "maxTokens": 8}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 820, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 200, "count": 1}, {"value": 100, "count": 1}, {"value": 20, "count": 1}]}, "showCoins": true, "showBills": true, "label": "De slimste manier: €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks"}, "a11y": {"alt": "Uitleg: €5 biljet + €2 munt + €1 munt + 20 cent = €8,20 met slechts 4 stuks"}}],
      "conceptId": "make_amount_minimal_bills",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Vergeet de 20 cent achter de komma (€8,00)", "optionIndex": 1 },
        { "id": "geld.optel-fout", "label": "Pakt 20 + 10 cent i.p.v. 20 cent (€8,30)", "optionIndex": 2 },
        { "id": "geld.munt-vergeten", "label": "Pakt 10 cent i.p.v. 20 cent (€8,10)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Gebruik zo min mogelijk stuks door altijd de grootste munt of het grootste biljet te pakken dat past. Pak eerst het €5-biljet (1 stuk). Nog €3,20 over: pak €2 (1 stuk). Nog €1,20 over: pak €1 (1 stuk). Nog 20 cent over: pak 20 cent (1 stuk). Totaal: €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks.",
        "distractorExplanations": {
          "0": "Goed! €5 + €2 + €1 + 20 cent = €8,20 met slechts 4 stuks. Onthoud: pak telkens het grootste stuk dat past, dan heb je er vanzelf zo min mogelijk nodig.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €8,00. Maar dan mis je nog 20 cent. Onthoud: kijk altijd ook naar het bedrag achter de komma.",
          "2": "Je dacht waarschijnlijk dat 20 + 10 cent nodig was. Maar dat is 30 cent, en je hebt maar 20 cent nodig. Onthoud: één munt van 20 cent is precies genoeg.",
          "3": "Je dacht waarschijnlijk dat 10 cent genoeg was. Maar €8,10 is 10 cent te weinig — je hebt 20 cent nodig. Onthoud: pak de munt die precies past."
        }
      }
    },
    {
      "id": "GELD-MAAK-005",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €3,85 met munten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€3,85", "€3,80", "€3,90", "€4,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 385,
          "allowedDenoms": [
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"},
            {"valueCents": 5, "type": "coin", "label": "5 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 385, "breakdown": {"coins": [{"value": 200, "count": 1}, {"value": 100, "count": 1}, {"value": 50, "count": 1}, {"value": 20, "count": 1}, {"value": 10, "count": 1}, {"value": 5, "count": 1}]}, "showCoins": true, "label": "Zo maak je €3,85: €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85"}, "a11y": {"alt": "Uitleg: €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85"}}],
      "conceptId": "make_amount_complex",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Stopt bij €3,80 en vergeet de laatste 5-centmunt", "optionIndex": 1 },
        { "id": "geld.optel-fout", "label": "Pakt een 5-centmunt te veel (€3,90)", "optionIndex": 2 },
        { "id": "geld.afronden-naar-50", "label": "Rondt onterecht af naar een rond bedrag (€4,00)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past en werk naar beneden. Pak eerst €2 (grootste munt ≤ €3,85). Pak dan €1 (samen €3). Je hebt nog 85 cent nodig: 50 cent + 20 cent + 10 cent + 5 cent = 85 cent. Tel op: €3 + 85 cent = €3,85.",
        "distractorExplanations": {
          "0": "Goed! €2 + €1 + 50 cent + 20 cent + 10 cent + 5 cent = €3,85. Onthoud: bouw de centen ook van groot naar klein op, dan vergeet je niets.",
          "1": "Je dacht waarschijnlijk dat je klaar was bij €3,80. Maar dat is 5 cent te weinig — de laatste 5-centmunt ontbreekt. Onthoud: tel alle munten na.",
          "2": "Je dacht waarschijnlijk dat je een munt extra nodig had. Maar €3,90 is 5 cent te veel. Onthoud: controleer of je geen extra 5-centmunt hebt gepakt.",
          "3": "Je dacht waarschijnlijk dat je naar €4,00 mocht afronden. Maar dat is 15 cent te veel. Onthoud: bij geld maken rond je nooit af — maak precies het bedrag."
        }
      }
    },
    {
      "id": "GELD-MAAK-006",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "money",
      "question": "Maak precies €7,60 met munten en biljetten.",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€7,60", "€7,50", "€7,70", "€8,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "make_amount",
          "currency": "EUR",
          "targetCents": 760,
          "allowedDenoms": [
            {"valueCents": 500, "type": "bill", "label": "€5"},
            {"valueCents": 200, "type": "coin", "label": "€2"},
            {"valueCents": 100, "type": "coin", "label": "€1"},
            {"valueCents": 50, "type": "coin", "label": "50 cent"},
            {"valueCents": 20, "type": "coin", "label": "20 cent"},
            {"valueCents": 10, "type": "coin", "label": "10 cent"}
          ],
          "constraints": {"maxTokens": 10}
        }
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 760, "breakdown": {"bills": [{"value": 500, "count": 1}], "coins": [{"value": 200, "count": 1}, {"value": 50, "count": 1}, {"value": 10, "count": 1}]}, "showCoins": true, "showBills": true, "label": "Zo maak je €7,60: €5 + €2 + 50 cent + 10 cent = €7,60"}, "a11y": {"alt": "Uitleg: €5 biljet + €2 munt + 50 cent + 10 cent = €7,60"}}],
      "conceptId": "make_amount_large",
      "variantIndex": 6,
      "citoDifficulty": 0.16,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Stopt bij €7,50 en vergeet de 10-centmunt", "optionIndex": 1 },
        { "id": "geld.optel-fout", "label": "Pakt een 10-centmunt te veel (€7,70)", "optionIndex": 2 },
        { "id": "geld.afronden-naar-50", "label": "Rondt onterecht af naar een rond bedrag (€8,00)", "optionIndex": 3 }
      ] },
      "feedback": {
        "explanationText": "Begin met het grootste biljet en werk naar beneden. Pak het €5-biljet. Pak dan de €2-munt (samen €7). Je hebt nog 60 cent nodig: 50 cent + 10 cent = 60 cent. Tel op: €5 + €2 + 50 cent + 10 cent = €7,60.",
        "distractorExplanations": {
          "0": "Goed! €5 + €2 + 50 cent + 10 cent = €7,60. Onthoud: splits de centen handig op — 60 cent is 50 + 10.",
          "1": "Je dacht waarschijnlijk dat 50 cent genoeg was voor de centen. Maar dan mis je nog 10 cent. Onthoud: na 50 cent heb je nog 10 cent nodig om op 60 te komen.",
          "2": "Je dacht waarschijnlijk dat je een munt extra nodig had. Maar 50 + 10 = 60 cent, niet 70. Onthoud: tel de centen na voor je stopt.",
          "3": "Je dacht waarschijnlijk dat je naar €8,00 mocht afronden. Maar dat is 40 cent te veel. Onthoud: maak precies €7,60, niet een rond getal."
        }
      }
    },
    {
      "id": "GELD-MAAK-007",
      "familyId": "GELD-MAAK",
      "module": "Geld",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_bedrag_maken",
      "questionType": "matching",
      "question": "Koppel de bedragen aan de juiste munten/biljetten combinatie.",
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "matching": {
          "pairs": [
            {"left": "€2,50", "right": "2×€1 + 1×50ct"},
            {"left": "€1,75", "right": "1×€1 + 1×50ct + 1×20ct + 1×5ct"},
            {"left": "€3,00", "right": "3×€1"},
            {"left": "€5,50", "right": "1×€5 + 1×50ct"}
          ]
        }
      },
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 250, "showCoins": true, "showBills": false, "breakdown": {"coins": [{"value": 100, "count": 2}, {"value": 50, "count": 1}], "bills": []}, "label": "Voorbeeld: €2,50 = 2×€1 + 1×50 cent. Tel de munten bij elkaar op."}}],
      "conceptId": "money_composition_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.14,
      "citoDiscrimination": 0.79,
      "stimulusAids": [],
      "pedagogy": { "dok": 1, "misconceptionTags": [
        { "id": "geld.optel-fout", "label": "Telt de muntcombinatie verkeerd op" },
        { "id": "geld.aantal-genegeerd", "label": "Negeert het aantal munten (telt 2×€1 als €1)" },
        { "id": "geld.cent-als-decimaal-verward", "label": "Haalt euro's en centen door elkaar bij de komma" }
      ] },
      "feedback": {
        "explanationText": "Tel bij elk bedrag de munten stap voor stap op. €2,50 = 2×€1 + 50 cent. €1,75 = €1 + 50 cent + 20 cent + 5 cent. €3,00 = 3×€1. €5,50 = €5 + 50 cent.",
        "distractorExplanations": {
          "0": "Goed! Je hebt alle bedragen aan de juiste muntcombinatie gekoppeld. Onthoud: tel elke combinatie eerst zelf op en zoek dan het bijpassende bedrag.",
          "1": "Je dacht waarschijnlijk dat de combinaties klopten zonder ze op te tellen. Onthoud: tel elke combinatie apart op en vergelijk met het bedrag links.",
          "2": "Je dacht waarschijnlijk aan andere muntwaarden. Onthoud: €1 = 100 cent en 50 cent is een halve euro — tel daarmee stap voor stap op.",
          "3": "Je dacht waarschijnlijk dat de euro's en centen los stonden. Onthoud: de komma scheidt euro's van centen — links zie je precies hoeveel van elk je nodig hebt."
        }
      }
    }
  ]
}